import _ from 'lodash'

function locksReducer(state = {}, action = {}) {
  switch (action.type.toUpperCase()) {
    case 'OPEN_STREAM':
      if (
        state.patient &&
        Array.isArray(state.patient) &&
        state.patient.length > 0 &&
        state.patient[0].patient_id != action.id
      ) {
        // we opened a stream with a patient_id (id) that is different
        // from the patient_id in the current locks array so we should
        // reset the array.
        return {
          ...state,
          patient: []
        }
      }
      return state
    case 'STORE_PATIENT_LOCK_DELETE':
      // normally stream would handle removing of the locks but if the stream
      // is closed before a lock is deleted watching for this action can handle it
      return {
        ...state,
        patient: [
          ...state.patient.filter(
            patientLock => patientLock.lock_id !== action.result.lock_id
          )
        ]
      }
    case 'STORE_PATIENT_LOCK_STREAM':
      if (!_.isEqual(action.result, state.patient)) {
        return {
          ...state,
          patient: action.result
        }
      } else {
        return state
      }
    default:
      return state
  }
}

export default locksReducer
